$(function() {
    const $footer = $('footer.page-footer'),
        $navTitle = $('.js-footer-nav-title');

    if (window.matchMedia("(max-width: 480px)").matches) {
        $navTitle.next().slideUp();
        $navTitle.on('click', function () {
            $(this).toggleClass('open');
            $(this).next().slideToggle();
        });
    }
});
